import { PatientConstants } from "../constants";

const initialstate = {
  loading: false,
  patientRequest: false,
  patientSuccess: false,
  patientFailure: false,
  items: [],
  selectedPatient:'',
  response:''
};

export function patients(state = initialstate, action) {
  switch (action.type) {
    case PatientConstants.GETPATIENTS_REQUEST:
      return {
        ...state,
        loading: true,
        patientRequest: true,
        patientFailure: false,
        patientSuccess: false,
        patients: action.response,
      };
    case PatientConstants.GETPATIENTS_SUCCESS:
      return {
        ...state,
        items: action.payload,
        loading: false,
        patientRequest: false,
        patientFailure: false,
        patientSuccess: true,
        patients: action.patients,
      };
    case PatientConstants.GETPATIENTS_FAILURE:
      return {
        ...state,
        loading: false,
        patientRequest: false,
        patientSuccess: false,
        patientFailure: true,
        patients: action.response,
      };

      case PatientConstants.CREATEPATIENTS_REQUEST:
      return {
        ...state,
        loading: true,
        patientRequest: true,
        patientFailure: false,
        patientSuccess: false,
        message: ''
      };
    case PatientConstants.CREATEPATIENTS_SUCCESS:
      return {
        ...state,
        items: action.payload,
        loading: false,
        patientRequest: false,
        patientFailure: false,
        patientSuccess: true,
        message: action.patients,
      };
    case PatientConstants.CREATEPATIENTS_FAILURE:
      return {
        ...state,
        loading: false,
        patientRequest: false,
        patientSuccess: false,
        patientFailure: true,
        message: action.data,
      };
    case PatientConstants.SELECTED_PATIENT:
      return{
          ...state,
          selectedPatient:action.id
      }
    case PatientConstants.RESET_PATIENT:
      return{
        ...state,
        selectedPatient:''
        }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/patient.reducer.js